import React, { useState } from 'react'
import { FormError } from 'components/atoms'
import styles from './FormPassword.module.sass'

interface Props {
  id: string
  placeholder?: string
  name?: string
  value?: string
  className?: string
  readOnly?: boolean
  required?: boolean
  disabled?: boolean
  size?: 'md' | 'lg'
  status?: '' | 'success' | 'error'
  errorMessage?: string
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const FormPassword = (props: Props) => {
  const {
    id = '',
    placeholder = '',
    name = '',
    value = '',
    className = '',
    readOnly = false,
    required = false,
    disabled = false,
    size = 'md',
    status = '',
    errorMessage = '',
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
  } = props

  const classNames = `
    ${styles.root}
    ${size ? styles[`root--${size}`] : ''}
    ${status ? styles[`root--${status}`] : ''}
    ${className}`

  return (
    <div className={classNames}>
      <div className={styles.inputWrap}>
        <input
          id={id}
          type={'password'}
          name={name}
          value={value}
          className={styles.input}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          readOnly={readOnly}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          aria-required={required}
          aria-describedby={status === 'error' ? `${id}_error` : undefined}
          aria-invalid={status === 'error'}
        />
      </div>
      <FormError
        id={`${id}_error`}
        className={styles.error}
        message={errorMessage}
        visible={status === 'error'}
      />
    </div>
  )
}

export default FormPassword
